import { chakra, Code } from '@chakra-ui/react';
import React from 'react';

import type { FormFields } from '../types';

import { useI18n } from 'lib/i18n/context';
import FormFieldText from 'ui/shared/forms/fields/FormFieldText';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { CONTRACT_VERIFICATION_FIELD_KEYS } from '../i18n';

interface Props {
  hint?: string;
}

const ContractVerificationFieldName = ({ hint }: Props) => {
  const { t } = useI18n();
  return (
    <ContractVerificationFormRow>
      <FormFieldText<FormFields>
        name="name"
        isRequired
        placeholder={ t(CONTRACT_VERIFICATION_FIELD_KEYS.name.placeholder) }
        size="md"
        rules={{ maxLength: 255 }}
        inputSx={{
          height: '48px !important',
          minHeight: '48px !important',
        }}
      />
      { hint ? <span>{ hint }</span> : (
        <>
          <span>{ t(CONTRACT_VERIFICATION_FIELD_KEYS.name.hintPart1) } </span>
          <Code color="text_secondary">{ `contract MyContract {..}` }</Code>
          <span>. <chakra.span fontWeight={ 600 }>MyContract</chakra.span> { t(CONTRACT_VERIFICATION_FIELD_KEYS.name.hintPart3) }</span>
        </>
      ) }
    </ContractVerificationFormRow>
  );
};

export default React.memo(ContractVerificationFieldName);
